module.exports = __webpack_public_path__ + "img/index-01.ec60707b.jpg";